import * as React from "react";

const PlayIcon = ({ color = "currentColor", style = {}, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={20}
    height={20}
    style={style}
    {...props}
  >
    <path
      d="M481.6 270.6L48.7 506C28.8 517.1 3.6 501.4 3.6 476V36C3.6 10.6 28.8-5.1 48.7 6L481.6 241.4C504.6 253.9 504.6 284.1 481.6 270.6z"
      fill={color} 
      style={{
        strokeLinecap: "round", 
        strokeLinejoin: "round", 
      }}
    />
  </svg>
);

export default PlayIcon;

